import {Component, ViewChild} from "@angular/core";
import {NavigationService} from "../../orchestration/navigation.service";
import {LoadingService} from "../../ui-elements/loading/loading.service";
import {Page} from "../../orchestration/page";
import {NotificationService} from "../../notification/notification.service";
import {MessageDetails, MessageLevel} from "../../notification/message/message";
import {IdentityModel} from "../../identity/identity.model";
import {FormComponent} from "../../inputs/form/form.component";
import {NavigationParams} from "../../orchestration/navigation-params";
import {MemberSalesData} from "../../identity/member-sales-search.model";
import {InvoiceEmailRequestData, InvoiceEmailRequestService} from "../invoice-email-request.service";
import {EntityData} from "@fedelta-pos/data-client";
import {RecentOrderData} from "../../order/recent-order.service";

@Component({
    selector: "woa-invoice-request-page",
    templateUrl: "./invoice-request-page.component.html",
    providers: [
        InvoiceEmailRequestService,
        {provide: Page, useExisting: InvoiceRequestPageComponent}
    ]
})
export class InvoiceRequestPageComponent extends Page {
    @ViewChild(FormComponent) public form: FormComponent;

    recentOrder: RecentOrderData;
    sale: MemberSalesData;
    email: string;
    sending: boolean = false;

    constructor(navigationParams: NavigationParams,
                private notificationService: NotificationService,
                private navigationService: NavigationService,
                private loadingService: LoadingService,
                private invoiceEmailRequestService: InvoiceEmailRequestService,
                private identityModel: IdentityModel) {
        super();
        this.recentOrder = navigationParams.get("recentOrder");
        this.sale = navigationParams.get("sale");
        this.email = this.recentOrder ? this.recentOrder.orderPlacement.email :
            this.identityModel.currentMember ? this.identityModel.currentMember.contact.email :
                undefined;
    }

    async requestInvoice(): Promise<void> {
        if (!this.form.valid) {
            return;
        }

        this.sending = true;
        try {
            await this.loadingService.performWithSpinner(async () => {
                const request: InvoiceEmailRequestData = EntityData.create(InvoiceEmailRequestData);
                request.customerRefNo = this.recentOrder ? this.recentOrder.placedOrder.lookupCode : this.sale.customerRefNo;
                request.email = this.email;
                await this.invoiceEmailRequestService.performAction(request);
                await this.navigationService.dismissPage(this, true);
            });
        } catch (error) {
            console.log(error);
            this.notificationService.displayFooterMessage(new MessageDetails(MessageLevel.ERROR, "woa.error.invoice.failed"));
        }
        this.sending = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/customer-info/invoice-request-page/invoice-request-page.component.ts